import styled from "styled-components";
import {OrderFilterOptionValueWithoutIncomplete, orderStatusColors} from ".";

export const StyledServiceOrderCard = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  position: relative;
  background-color: #fff;
  min-height: 10.6rem;
`;
export const StyledServiceOrderCardContentButtonWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  display: block;
  width: 100%;
  height: 100%;

  margin: 0;
  padding: 0;
  border: none;
  background-color: transparent;
  color: inherit;
  font: inherit;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  cursor: pointer;
`;

export const StyledServiceOrderCardSideCap = styled.div<{
  $status: OrderFilterOptionValueWithoutIncomplete;
}>`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  width: 9px;
  background-color: ${({$status}) => orderStatusColors[$status]};
  border-radius: 4px 0 0 4px;
`;

export const StyledServiceOrderCardBody = styled.div`
  width: 100%;
  padding: 1.2rem;
`;
export const StyledServiceOrderCardBodyContent = styled.div`
  width: 100%;
`;

export const StyledServiceOrderCardBodyContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const StyledServiceOrderCardBodyContentHeaderOrderTime = styled.p`
  color: #8c8c8c;
  font-size: 1.2rem;
`;
export const StyledServiceOrderCardBodyContentHeaderDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.2rem;

  .project-name {
    font-weight: 600;
    font-size: 1.4rem;
    color: #1c1726;
  }
`;
export const StyledServiceOrderCardBodyContentDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
  padding-top: 1.2rem;

  @media (max-width: 430px) {
    flex-direction: column;
  }
`;
export const StyledServiceOrderCardBodyContentDetailsItem = styled.p`
  font-weight: 400;
  font-size: 1.2rem;
  color: #8c8c8c;

  .item-value {
    color: #1c1726;
  }
`;

export const StyledServiceOrderGreyText = styled.p`
  color: #595959;
  font-size: 1.2rem;
  font-weight: 400;
`;
